import React from 'react'
import ReactDOM from 'react-dom'
import { debounce } from 'lodash'
import { transform } from 'popmotion'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Responsive from 'react-responsive';
import { Carousel } from '../../index'
import Link from 'gatsby-link'
import { TweenMax, Power2, TimelineLite } from "gsap/umd/TweenMax"; 
import Draggable from "gsap/umd/Draggable";

import { media, breakpoints, width, isClient } from '../../../styles/utils'
import { container, bgIcon, padding, hoverState, bgImage } from '../../../styles/global'
import { ribbon } from '../../../styles/colors';
import { heading, paragraph } from '../../../styles/type';
import { injectGlobal } from 'emotion';

// Import ThrowPropsPlugin on client only

if (isClient()) {
	require('../../../lib/ThrowPropsPlugin')
}

const { interpolate } = transform

class BlockCaseStudy extends React.Component {

	constructor(props) {
		super(props);
		this.scrollWrapper = React.createRef();
	}

	state = {
		scrollPos: 0
	}

	componentDidMount = () => {
		const self = this;

		Draggable.create(".scroll-wrapper", {
			type: "scrollLeft",
			edgeResistance: 0.95,
			throwProps: true,
            dragClickables: true,
            cursor: 'grab',
			onDrag: function() {
				self.onScroll(-this.x)
			},
			onThrowUpdate: function() {
				self.onScroll(-this.x)
			},
		});
	}

	onScroll = (scrollPos) => {		
		if (!width.phone()) {
			this.setState({
				scrollPos: scrollPos,
				scrollMax: ReactDOM.findDOMNode(this.scrollWrapper.current).getBoundingClientRect().width - window.innerWidth
			})
		}
	}

	renderDesktopInfo = () => {
		const { description } = this.props;
		const opacity = interpolate([0, 600], [1, 0])

		return (
			<Info
				style={{
					opacity: opacity(this.state.scrollPos)
				}}
			>
				<Heading>Hornsby Residences</Heading>
				<Description
					dangerouslySetInnerHTML={{__html: description}}
				/>
				<div/>
			</Info>
		)
	}


	renderMobileInfo = () => {
		const { description } = this.props;

		return (
			<Info>
				<Heading>Hornsby Residences</Heading>
				<Description
					dangerouslySetInnerHTML={{__html: description}}
				/>
				<Button
					to={'/casestudy'}
				>
					See the case study
				</Button>
			</Info>
		)
	}

	renderSlider = () => {
		return (
			<Carousel
				slides={this.renderImages()}
				ref={this.slider}
				styles={carouselStyles}
				settings={{
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					speed: 1000,
					arrows: false,
					dots: false,
					dragging: true,
					centerMode: true,
					centerPadding: '57px',
				}}
			/>
		)
	}

	renderScroll = () => {
		return (
			<div
				className={'scroll-wrapper'}
				onWheel={(e) => this.onScroll(e.currentTarget.scrollLeft)}
				style={{
					display: 'flex',
				}}
			>
				<ScrollWrapper
					ref={this.scrollWrapper}
				>
					{this.renderImages()}

					<Button
						to={'/casestudy'}
					>
						See the case study
					</Button>
				</ScrollWrapper>
			</div>
		)
	}

	renderImages = () => {
		const { slider } = this.props;

		return slider.map((slide, i) => {
			return (
				<Image
					key={i}
					image={slide.image.sizes.medium_large}
				/>
			)
		})
	}
	
	render() {
		const { paragraph } = this.props;
		const { scrollPos, scrollMax } = this.state;

		return (
			<Wrapper>	
				<Button
					to={'/casestudy'}
					style={{
						opacity: scrollPos > (scrollMax - 200) ? 0 : 1,
						background: `rgba(255,255,255, ${scrollPos > 500 ? 1 : 0.5})`
					}}
				>
					See the case study
				</Button>


				{/* Horizontal Scroll */}

				<Responsive minWidth={breakpoints.phone}>
					{this.renderDesktopInfo()}
					{this.renderScroll()}
				</Responsive>

				{/* Slider */}

				<Responsive maxWidth={breakpoints.phone}>
					{this.renderSlider()}
					{this.renderMobileInfo()}
				</Responsive>

			</Wrapper>
		)
	}
}

// Shared

const Heading = styled.div``
const Description = styled.div``
const Button = styled(Link)`
	height: 50px;
	padding-left: 20px;
	padding-right: 20px;
	white-space: nowrap;
	font-family: 'Scto';
	font-size: 16px;
	background: rgba(255,255,255,0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	transition: background 0.25s ease, opacity 0.25s ease;

	&:hover {
		background: rgba(255,255,255,1) !important;
	}

	${media.laptop`
		font-size: 12px;
		height: 37px;
	`}
`

// Wrapper

const Wrapper = styled.div`
	display: flex;
	/* overflow-x: scroll; */
	overflow: hidden;

	*::-webkit-scrollbar {
		display: none;
	}

	> ${Button} {
		position: absolute;
		bottom: 20px;
		left: 15rem;
		z-index: 3;

		${media.phone`
			display: none;
		`}
	}

	${media.phone`
		flex-direction: column;
		align-items: center;
	`}
`

const ScrollWrapper = styled.div`
	display: flex;
	padding: 0 15rem;
	padding-left: calc(15rem + 400px + 10rem);
	position: relative;
	z-index: 1;

	${Button} {
		align-self: center;
		margin-left: 5rem;
	}

	${media.laptop`
		padding-left: calc(15rem + 300px + 10rem);
	`}

	${media.tablet`
		padding-left: calc(15rem + 260px + 5rem);
	`}
`

injectGlobal`
	.scroll-wrapper {
		> * {
			display: flex !important;
		}
	}
`

// Info

const Info = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	position: absolute;
	left: 15rem;
	top: 15rem;
	bottom: 15rem;

	${Heading} {
		${heading}
		padding-top: 20px;
		text-align: left !important;
	}

	${Description} {
		width: 400px;
		max-width: 100%;

		${media.laptop`
			width: 300px;
		`}

		${media.tablet`
			width: 260px;
		`}

		${media.phone`
			width: 60rem;
		`}

		p {
			${paragraph}
		}
	}

	${media.phone`
		position: static;
		align-items: center;
		width: 100%;
		margin-top: 40px;
		${padding};

		${Heading} {
			text-align: center !important;
			margin-bottom: 24px;
		}

		${Button} {
			margin-top: 30px;
		}
	`}
`

// Images

const Image = styled.div`
	width: 500px;
	height: 700px;
	background-image: url(${props => props.image});
	${bgImage}
	margin-right: 10rem;

	${media.laptop`
		height: 520px;
		width: 360px;
	`}

	${media.tablet`
		height: 440px;
		width: 300px;
		margin-right: 5rem;
	`}

	${media.phone`
		margin: 0 15px;
		height: 310px;
		width: auto;
	`}
`

// Slider

const carouselStyles = css`
	position: relative;
	overflow: hidden;
	width: 100vw;
`



BlockCaseStudy.wrapper = css`

`

export default BlockCaseStudy



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockCaseStudy.js